var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinersConfirmationIcon = function SvgDinersConfirmationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 75.723 75.723"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.861,
    cy: 37.861,
    r: 37.861,
    fill: "#37B4C3",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.861,
    cy: 37.861,
    r: 23.756,
    fill: "#37B4C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M46.161 31.707 35.522 42.554a.5.5 0 0 1-.718-.004l-4.643-4.843"
  })));
};
export default SvgDinersConfirmationIcon;